'use client';

import React from 'react';
import { cn } from '@/utils';

export interface VideoRecommendationProps {
  isVideoEnabled: boolean;
}

/** Desktop-only recommendation to use video (hidden in audio-only mode). */
export const VideoRecommendation: React.FC<VideoRecommendationProps> = ({ isVideoEnabled }) => (
  <div
    className={cn('mx-auto max-w-[629px] text-center hidden sm:block', {
      hidden: !isVideoEnabled,
    })}
  >
    <p className="font-text text-body leading-6 font-bold text-neutral-gray-700">
      For the best experience, we recommend using video. If you experience Wi-Fi or connectivity
      issues, you may switch to audio only.
    </p>
  </div>
);
